import { Fragment, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import classes from "./TableWithShowInfoColumn.module.css";
import TableColumnTitles from "./TableColumnTitles/TableColumnTitles";
import TableColumnSearchInputs from "./TableColumnSearchInputs/TableColumnSearchInputs";
import TableFooter from "./TableFooter/TableFooter";
import TableBody from "./TableBody/TableBody";
import TableFeatures from "./TableFeatures/TableFeatures";
import { Grid } from "@mui/material";
import TableLoadingSpinner from "./TableLoadingSpinner/TableLoadingSpinner";
import arabicToPersian from "../../utils/textUtils/arabic-to-persian-convertor";
import TableHeader from "./TableHeader/TableHeader";
import { LanguageContext } from "../../store/language-context";
import readListUIStateFromIndexedDB from "../../utils/cache/ListUiState/readListUIStateFromIndexedDB";

const TableWithShowInfoColumn = ({
  datas,
  editablelity = false,
  addEditRowComponent,
  actionHandler,
  sendReqPerChange,
  totalRecords,
  view,
  selectable = false,
  isLoading,
  selectedRows,
  setSelectedRows,
  canAdd,
  canEdit,
  canInsertEdition,
  canInsertEditionAddress,
  canViewForm,
  canDelete,
  searchRowComponent: SearchRowComponent,
  sendGetReqNow,
  setSendGetReqNow,
  forceLtr,
  actionStatus,
  setActionStatus,
  tableInfos,
  setTableInfos,
  clonedTableInfos,
  fieldAccessesAreLoading,
  enumOptions,
  rowClickable,
  isProcessual,
  pageHeader,
  headerIcon,
  customWidth,
  customChangeSelectedRowsHandler,
  customChecked,
  persistKey,
  additionalHeaderEndPartJsx,
  canSelectAll = true,
  customAddTxt,
}) => {
  // sortIconName = sort
  const [sortIconName, setSortIconName] = useState({});
  // searchVal = search
  const [searchVal, setSearchVal] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [dataLimit, setDataLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [fullScreen, setFullScreen] = useState(false);
  const [density, setDensity] = useState("normal");
  const [showSearchRow, setShowSearchRow] = useState(true);
  const [searchTypes, setSearchTypes] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [tableWidth, setTableWidth] = useState(null);
  const { userLanguage } = useContext(LanguageContext);

  // const [searchTypes, setSearchTypes] = useState(() => {
  //   // const mainKeys = tableInfos?.map((inf) => inf.uniqueName);
  //   // const initialSearchVals = {};
  //   // for (const each of mainKeys) {
  //   //   initialSearchVals[each] = "include";
  //   // }
  //   // return initialSearchVals;
  //   const initialSearchVals = {};
  //   for (const each of tableInfos) {
  //     if (tableInfos?.type === "date" || tableInfos?.type === "rangedNumber") {
  //       initialSearchVals[each] = { from: "", to: "" };
  //     } else initialSearchVals[each] = "include";
  //   }
  //   return initialSearchVals;
  // });
  const tableRef = useRef(null);

  useEffect(() => {
    setPages(Math.ceil(totalRecords / dataLimit));
    setCurrentPage(1);
  }, [dataLimit, totalRecords]);

  useEffect(() => {
    let isMounted = true;

    const buildInitialState = () => {
      const mainKeys = tableInfos?.map((inf) => inf.uniqueName);
      // const initialSearchVal = {};
      // for (const each of mainKeys) {
      //   initialSearchVal[each] = "";
      // }
      // setSearchVal(initialSearchVal);
      const initialSearchVal = {};
      const initialSortType = {};
      const initialSearchType = {};

      for (const each of tableInfos) {
        if (each?.type === "date" || each?.type === "rangedNumber")
          initialSearchVal[each.uniqueName] = { from: "", to: "" };
        else
          initialSearchVal[each.uniqueName] = each?.initialSearchedValue
            ? each.initialSearchedValue
            : "";
      }
      for (const each of mainKeys) {
        initialSortType[each] = "";
      }
      for (const each of mainKeys) {
        initialSearchType[each] = "include";
      }
      return {
        search: initialSearchVal,
        sort: initialSortType,
        searchTypes: initialSearchType,
        dataLimit: 10,
        tableWidth: null,
      };
    };
    const hydrate = async () => {
      try {
        const saved = await readListUIStateFromIndexedDB(persistKey || "List");

        if (!isMounted) return;

        const baseState = buildInitialState();

        if (saved && persistKey) {
          const hasValidSortInIndexDB =
            saved?.sort && typeof saved?.sort === "object" && Object.keys(saved?.sort).length > 0;
          setDataLimit(saved?.dataLimit ?? baseState.dataLimit);
          setSearchVal(saved?.search ?? baseState.search);
          // setSearchVal(baseState.search);
          // setSortIconName(saved?.sort ?? baseState.sort);
          setSortIconName(hasValidSortInIndexDB ? saved.sort : baseState.sort);
          // setSearchTypes(saved?.searchTypes ?? baseState.searchTypes);
          setSearchTypes(baseState.searchTypes);
          setTableWidth(saved?.tableWidth ?? baseState.tableWidth);
          // setTableWidth(baseState.tableWidth);
        } else {
          setDataLimit(baseState.dataLimit);
          setSearchVal(baseState.search);
          setSortIconName(baseState.sort);
          setSearchTypes(baseState.searchTypes);
          setTableWidth(baseState.tableWidth);
        }
      } catch (err) {
        console.error("Hydration in TableWithShowInfoColumn failed:", err);
      }
    };

    hydrate();

    return () => {
      isMounted = false;
    };
  }, [tableInfos.length]);

  useEffect(() => {
    if (sendGetReqNow) {
      let searchValsArrayInOrder = Object.values(searchVal);
      let sortValsInOrder = [...Object.values(sortIconName)];
      // sendReqPerChange(...sortValsInOrder, currentPage, dataLimit, true, ...searchValsArrayInOrder);
      let fetchAttributes = {
        searchTypes,
        search: { ...searchVal },
        sort: { ...sortIconName },
        page: currentPage,
        dataLimit,
        shouldFetchTotalNumber: true,
      };
      sendReqPerChange(fetchAttributes);
      setSendGetReqNow(false);
    }
  }, [sendGetReqNow]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (tableRef.current) {
        // console.log("table is ready");
        setTableWidth(tableRef.current.offsetWidth);
        clearInterval(interval);
      }
    }, 50);

    return () => clearInterval(interval);
  }, []);
  // =======================================*** CHECKBOX SELECT FUNCS ***================================

  const selectAllRowsHandler = (confirmation) => {
    if (selectable) {
      if (confirmation) {
        if (isProcessual) {
          if (Array.isArray(datas)) {
            const properDatas = datas.map((each) => each[0]);
            setSelectedRows(properDatas);
          }
        } else {
          setSelectedRows(datas);
        }
      } else {
        setSelectedRows([]);
      }
    }
  };
  const changeDensityHandler = (e) => {
    e.preventDefault();
    setDensity((prevState) => {
      if (prevState === "normal") {
        return "compact";
      } else if (prevState === "compact") {
        return "large";
      } else if (prevState === "large") {
        return "normal";
      }
    });
  };
  // =======================================***SEARCH & SORT FUNCS***================================

  const searchHandler = (e) => {
    let searchInput = arabicToPersian(e.target.value);
    let searchNa = e.target.name;
    let searchValsInOrder = { ...searchVal };
    if (e.target?.subName) {
      setSearchVal((prevState) => ({
        ...prevState,
        [searchNa]: { ...prevState[searchNa], [e.target.subName]: searchInput },
      }));
      searchValsInOrder[searchNa][e.target.subName] = searchInput;
    } else {
      setSearchVal((prevState) => ({ ...prevState, [searchNa]: searchInput }));
      searchValsInOrder[searchNa] = searchInput;
    }

    // let searchValsArrayInOrder = Object.values(searchValsInOrder);
    // let sortValsInOrder = [...Object.values(sortIconName)];
    // sendReqPerChange(...sortValsInOrder, currentPage, dataLimit, true, ...searchValsArrayInOrder);

    let fetchAttributes = {
      searchTypes,
      search: { ...searchValsInOrder },
      sort: { ...sortIconName },
      page: currentPage,
      dataLimit,
      shouldFetchTotalNumber: true,
    };
    sendReqPerChange(fetchAttributes);
    setCurrentPage(1);
  };
  const sortNameHandler = (keyy) => {
    let currentOrder = sortIconName[keyy];
    let newOrder;
    if (currentOrder === "") {
      newOrder = "asc";
    } else if (currentOrder === "asc") {
      newOrder = "desc";
    } else if (currentOrder === "desc") {
      newOrder = "";
    }
    let copiedSortValsInOrder = { ...sortIconName };
    copiedSortValsInOrder[keyy] = newOrder;
    let newSortValsInOrder = [...Object.values(copiedSortValsInOrder)];
    setSortIconName((prevState) => ({
      ...prevState,
      [keyy]: newOrder,
    }));
    let searchValsInOrder = [...Object.values(searchVal)];

    // sendReqPerChange(...newSortValsInOrder, currentPage, dataLimit, false, ...searchValsInOrder);
    let fetchAttributes = {
      searchTypes,
      search: { ...searchVal },
      sort: { ...copiedSortValsInOrder },
      page: currentPage,
      dataLimit,
      shouldFetchTotalNumber: false,
    };
    sendReqPerChange(fetchAttributes);
  };
  // const searchTypeHandler = (name, type, searchedRangeValue) => {
  //   let newSearchTypes = { ...searchTypes };
  //   if (searchedRangeValue) {
  //     setSearchTypes((prevState) => ({
  //       ...prevState,
  //       [name]: { ...prevState[name], [type]: searchedRangeValue },
  //     }));
  //     newSearchTypes[name][type] = searchedRangeValue;
  //     const properVal = newSearchTypes[name].from.concat(" - ", newSearchTypes[name].to);
  //     setSearchVal((prevState) => ({ ...prevState, [name]: properVal }));
  //   } else {
  //     setSearchTypes((prevState) => ({ ...prevState, [name]: type }));
  //     newSearchTypes[name] = type;
  //   }
  //   let fetchAttributes = {
  //     searchTypes: newSearchTypes,
  //     search: searchVal,
  //     sort: sortIconName,
  //     page: currentPage,
  //     dataLimit,
  //     shouldFetchTotalNumber: true,
  //   };
  //   sendReqPerChange(fetchAttributes);
  //   setCurrentPage(1);
  // };

  // =======================================***PAGINATION FUNCS***================================
  function changeDataLimitHandler(e) {
    setDataLimit(Number(e.target.value));

    let searchValsArrayInOrder = Object.values(searchVal);
    let sortValsInOrder = [...Object.values(sortIconName)];
    // sendReqPerChange(...sortValsInOrder, 1, e.target.value, false, ...searchValsArrayInOrder);
    let fetchAttributes = {
      searchTypes,
      search: { ...searchVal },
      sort: { ...sortIconName },
      page: 1,
      dataLimit: e.target.value,
      shouldFetchTotalNumber: false,
    };
    sendReqPerChange(fetchAttributes);
  }
  function goToNextPage() {
    let nextpage = currentPage + 1;
    setCurrentPage((prevState) => prevState + 1);
    //SEND GET REQ HERE
    let searchValsArrayInOrder = Object.values(searchVal);
    let sortValsInOrder = [...Object.values(sortIconName)];

    // sendReqPerChange(...sortValsInOrder, nextpage, dataLimit, false, ...searchValsArrayInOrder);
    let fetchAttributes = {
      searchTypes,
      search: { ...searchVal },
      sort: { ...sortIconName },
      page: nextpage,
      dataLimit,
      shouldFetchTotalNumber: false,
    };
    sendReqPerChange(fetchAttributes);
  }
  function goToPreviousPage() {
    let prevpage = currentPage - 1;
    setCurrentPage((prevState) => prevState - 1);
    //SEND GET REQ HERE
    let searchValsArrayInOrder = Object.values(searchVal);
    let sortValsInOrder = [...Object.values(sortIconName)];

    // sendReqPerChange(...sortValsInOrder, prevpage, dataLimit, false, ...searchValsArrayInOrder);
    let fetchAttributes = {
      searchTypes,
      search: { ...searchVal },
      sort: { ...sortIconName },
      page: prevpage,
      dataLimit,
      shouldFetchTotalNumber: false,
    };
    sendReqPerChange(fetchAttributes);
  }
  function changePage(e) {
    const pageNumber = Number(e.target.textContent);
    setCurrentPage(pageNumber);
    //SEND GET REQ HERE
    let searchValsArrayInOrder = Object.values(searchVal);
    let sortValsInOrder = [...Object.values(sortIconName)];

    // sendReqPerChange(
    //   ...sortValsInOrder,
    //   e.target.textContent,
    //   dataLimit,
    //   false,
    //   ...searchValsArrayInOrder
    // );
    let fetchAttributes = {
      searchTypes,
      search: { ...searchVal },
      sort: { ...sortIconName },
      page: e.target.textContent,
      dataLimit,
      shouldFetchTotalNumber: false,
    };
    sendReqPerChange(fetchAttributes);
  }

  return (
    <div
      className={[
        classes.transitionComponent,
        fullScreen ? classes.fullscreentableContainer : classes.normalScreenTableContainer,
      ].join(" ")}
    >
      <TableHeader
        pageHeader={pageHeader}
        headerIcon={headerIcon}
        setFullScreen={setFullScreen}
        fullScreen={fullScreen}
        density={density}
        selectable={selectable}
        selectAllRowsHandler={selectAllRowsHandler}
        changeDensityHandler={changeDensityHandler}
        setShowSearchRow={setShowSearchRow}
        actionHandler={actionHandler}
        editablelity={editablelity}
        canAdd={canAdd}
        forceLtr={forceLtr}
        actionStatus={actionStatus}
        setActionStatus={setActionStatus}
        tableInfos={tableInfos}
        setTableInfos={setTableInfos}
        clonedTableInfos={clonedTableInfos}
        persistKey={persistKey}
        additionalHeaderEndPartJsx={additionalHeaderEndPartJsx}
        customAddTxt={customAddTxt}
      />
      {!fieldAccessesAreLoading ? (
        <div
          // item
          // container
          // xs={12}
          className={[classes.tableRelativeParent, fullScreen ? classes.fixedHeight : null].join(" ")}
        >
          <div className={[classes.tableContainer].join(" ")}>
            <div className={fullScreen ? classes.scrollableTable : null}>
              <table ref={tableRef} className={classes.table}>
                <thead>
                  <TableColumnTitles
                    sortNameHandler={sortNameHandler}
                    sortIconName={sortIconName}
                    view={view}
                    selectable={selectable}
                    tableInfos={tableInfos}
                    selectAll={selectAll}
                    setSelectAll={setSelectAll}
                    selectAllRowsHandler={selectAllRowsHandler}
                    forceLtr={forceLtr}
                    tableWidth={tableWidth}
                    userLanguage={userLanguage}
                    customWidth={customWidth}
                    persistKey={persistKey}
                    canSelectAll={canSelectAll}
                  />

                  {SearchRowComponent ? (
                    <SearchRowComponent
                      tableInfos={tableInfos}
                      searchHandler={searchHandler}
                      view={view}
                      selectable={selectable}
                      showSearchRow={showSearchRow}
                    />
                  ) : (
                    <TableColumnSearchInputs
                      searchHandler={searchHandler}
                      view={view}
                      selectable={selectable}
                      showSearchRow={showSearchRow}
                      tableInfos={tableInfos}
                      searchVal={searchVal}
                      enumOptions={enumOptions}
                      setSearchVal={setSearchVal}
                      forceLtr={forceLtr}
                      setSearchTypes={setSearchTypes}
                      searchTypes={searchTypes}
                    />
                  )}
                </thead>
                <tbody className={classes.tbody}>
                  <TableBody
                    isLoading={isLoading}
                    dataLimit={dataLimit}
                    datas={datas}
                    view={view}
                    actionHandler={actionHandler}
                    editablelity={editablelity}
                    selectable={selectable}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    density={density}
                    addEditRowComponent={addEditRowComponent}
                    currentPage={currentPage}
                    sendReqPerChange={sendReqPerChange}
                    sortIconName={sortIconName}
                    searchVal={searchVal}
                    canEdit={canEdit}
                    canViewForm={canViewForm}
                    canInsertEdition={canInsertEdition}
                    canInsertEditionAddress={canInsertEditionAddress}
                    canDelete={canDelete}
                    forceLtr={forceLtr}
                    actionStatus={actionStatus}
                    setActionStatus={setActionStatus}
                    tableInfos={tableInfos}
                    setTableInfos={setTableInfos}
                    clonedTableInfos={clonedTableInfos}
                    rowClickable={rowClickable}
                    isProcessual={isProcessual}
                    searchTypes={searchTypes}
                    setCurrentPage={setCurrentPage}
                    userLanguage={userLanguage}
                    customChangeSelectedRowsHandler={customChangeSelectedRowsHandler}
                    customChecked={customChecked}
                  />
                </tbody>
              </table>
            </div>
          </div>
          <TableFooter
            changeDataLimitHandler={changeDataLimitHandler}
            totalRecords={totalRecords}
            currentPage={currentPage}
            dataLimit={dataLimit}
            goToPreviousPage={goToPreviousPage}
            goToNextPage={goToNextPage}
            changePage={changePage}
            pages={pages}
            forceLtr={forceLtr}
          />
        </div>
      ) : (
        <TableLoadingSpinner />
      )}
    </div>
  );
};

export default TableWithShowInfoColumn;
